import React, { useCallback } from "react";
import { Hits, useInstantSearch } from "react-instantsearch";
import SuggestionHit from "./SuggestionHit";
import { translate } from "../../../Services/translation";
import { AlgoliaPageLink } from "./types/AlgoliaPageLink";

interface AlgoliaSuggestionsProps {
  pageLinks: AlgoliaPageLink[];
}

const AlgoliaSuggestions = ({ pageLinks }: AlgoliaSuggestionsProps) => {
  const { results } = useInstantSearch();
  const hasNoResults =
    !results.__isArtificial && results.nbHits === 0 && pageLinks.length === 0;
  const transformItems = useCallback(
    (items) => {
      const pageLinksWithFlag = pageLinks.map((link, i) => ({
        ...link,
        isPageLink: true,
        objectID: "pagelink" + link.url,
      }));
      return [...items, ...pageLinksWithFlag];
    },
    [pageLinks]
  );

  return (
    <div
      className={`algolia-suggestions ${
        hasNoResults ? "algolia-suggestions--no-results" : ""
      }`}
    >
      <span className="algolia-suggestions__label algolia-search-results__mobile-padding">
        {translate("global.search.proposal")}
      </span>
      <div className="algolia-suggestions__list algolia-search-results__mobile-left-padding">
        <Hits
          hitComponent={SuggestionHit}
          classNames={{
            root: "",
            item: "algolia-suggestions__item-container",
          }}
          transformItems={transformItems}
        />
      </div>
    </div>
  );
};

export default AlgoliaSuggestions;
